module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAeCAQAAABZVYz/AAAA10lEQVQoFWNgwA/mC8yzmsuLU3re5rlP562exI5L+vu8/0C4eakgdumS+R/n/Z/7e97i2eLY7OaY1zz/G1D/z3nrsFoxiX3BZKAkbitWsS2oJmgF2JG4rZg/hYAV82rmfcJjRR8nCVYs4cNnxY95KVjDcSbXvLnz/s39PT8fi+R/xrk2814ADf8zrwRDsoFlfhRY8v/cc/O0MHTOj5r/DOywq3PVGRixG/tv3gWgJC5j512Yb4qhk/7GAtOaFU5jwdIPcRgLTSd3cBgLAUtk5qcuEmOgCQAA+TDLgbrjM6kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/img/more.png
// module id = 60
// module chunks = 2 4 7 10